import React, { useState } from 'react';
import { Path, UseFormRegister } from 'react-hook-form';
import { FieldErrors } from 'react-hook-form/dist/types/errors';

//TODO: delete any
interface IInputBox<T> {
  label: string,
  errorsObj: FieldErrors<T>
  id: string,
  name: Path<T>,
  required: boolean,
  readOnly?: boolean,
  pattern?: string,
  maxLength?: number,
  minLength?: number,
  placeholder?: string
  error?: string,
  autoComplete?: string,
  defaultValue?: string,
  tabIndex?: number,
  validate?: any,
  customStyle?: string,
  register?: UseFormRegister<T>
}

const InputPasswordBox = <T extends object>(props: IInputBox<T>) => {
  const {
    label,
    register,
    name,
    required,
    id,
    errorsObj,
    error,
    minLength,
    maxLength,
    validate,
    pattern,
    placeholder,
    customStyle,
  } = props;

  if (!register) {
    return null;
  }

  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className={`${customStyle} ${showPassword ? 'input-box show' : 'input-box'}`}>
      <input
        {...register(name, { required, minLength, maxLength, validate, pattern })}
        type={showPassword ? 'text' : 'password'}
        id={id}
        tabIndex={props.tabIndex}
        placeholder={placeholder || ' '}
        className={`input-box__input ${errorsObj[name] ? 'error' : ''}`} />
      {label && <label htmlFor={id} className={`input-box__label ${errorsObj[name] && 'error'}`}>{label}</label>}
      <button onClick={() => setShowPassword(!showPassword)} type="button" className="input-box__showhide">
        {showPassword && (
          <img src="/svg/eye-off.svg" alt="show" />
        ) || (
          <img src="/svg/eye-on.svg" alt="hide" />
        )}
      </button>
      {errorsObj[name] && <span className="error">{error}</span>}
      {/*<span className="error">test</span>*/}
    </div>
  );
};

export default InputPasswordBox;
